import * as React from 'react';

import { Storage } from 'aws-amplify';
import { useEffect, useRef, useState } from 'react';
import { Button } from '@chakra-ui/react';
import { useMutation } from '@apollo/client';
import { notifySaveFailure, notifySaveSuccess } from '~/components/atoms';

import { UserAvatar } from '~/components/molecules';
import { updateProfile } from '~/queries';
import { useUser } from '~/containers';

const ChangeProfileImage: React.FC = () => {
  const [image, setImage] = useState<string | undefined>(undefined);
  // TODO: エラーハンドリング
  const [updateImage, { error }] = useMutation(updateProfile);

  const { user, identityId, updateImage: updateCognitoImage } = useUser();
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (!hiddenFileInput?.current) return;
    hiddenFileInput.current.click();
  };

  useEffect(() => {
    setImage(user?.attributes?.picture);
  }, [user]);

  const onChange = async (file: File | null) => {
    if (file == null || user == null || identityId == null) return;

    const { key } = (await Storage.put(file.name, file, {
      contentType: file.type,
      level: 'protected',
    })) as { key: string | null };
    if (key == null) return;

    const uploadPath = `${identityId}/${key}`;
    await updateImage({ variables: { input: { image: uploadPath } } });
    await updateCognitoImage(uploadPath);
    setImage(uploadPath);

    notifySaveSuccess();
    if (error) {
      notifySaveFailure();
    }
  };

  return (
    <>
      <UserAvatar
        imageKey={image}
        size="xl"
        name={user?.attributes?.family_name}
      />
      <Button
        onClick={handleClick}
        ml={5}
        variant="outline"
        size="sm"
        fontWeight="medium"
        _focus={{ shadow: 'none' }}
      >
        画像を選択
      </Button>
      <input
        type="file"
        accept="image/*"
        ref={hiddenFileInput}
        onChange={(e) => onChange(e.target.files?.[0] || null)}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default ChangeProfileImage;
